import _slicedToArray from "/home/circleci/plumia-papers/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
import useLayoutEffect from './use-isomorphic-layout-effect';
export var colorSchemes = {
  light: '(prefers-color-scheme: light)',
  dark: '(prefers-color-scheme: dark)'
};

function onThemeChange(callback) {
  return function (event) {
    if (!event || !event.matches) {
      return;
    }

    callback();
  };
}

export default function useSystemTheme(initialTheme) {
  var _useState = useState(initialTheme || null),
      _useState2 = _slicedToArray(_useState, 2),
      theme = _useState2[0],
      setTheme = _useState2[1];

  useEffect(function () {
    // SSR or matchMedia not supported
    if (typeof window === 'undefined' || !window.matchMedia) {
      return;
    }

    var lightMatch = window.matchMedia(colorSchemes.light);
    var onLightMatches = onThemeChange(function () {
      return setTheme('light');
    });
    lightMatch.addListener(onLightMatches);
    var darkMatch = window.matchMedia(colorSchemes.dark);
    var onDarkMatches = onThemeChange(function () {
      return setTheme('dark');
    });
    darkMatch.addListener(onDarkMatches);
    return function () {
      lightMatch.removeListener(onLightMatches);
      darkMatch.removeListener(onDarkMatches);
    };
  }, []);
  useLayoutEffect(function () {
    // SSR or matchMedia not supported
    if (typeof window === 'undefined' || !window.matchMedia) {
      return;
    }

    if (window.matchMedia(colorSchemes.dark).matches && theme !== 'dark') {
      setTheme('dark');
    } else if (window.matchMedia(colorSchemes.light).matches && theme !== 'light') {
      setTheme('light');
    }
  }, [theme]);
  return theme;
}